var tabsItemSlot = 'fx_2d2fb1e5_159zix80';

export { tabsItemSlot };
//# sourceMappingURL=itemSlot.vanilla.mjs.map
